import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { throwError } from 'rxjs';
import { Platform } from '@ionic/angular';
import { tap } from 'rxjs/operators';
import { WebResponesContext,WebParameterContext } from '../model/common';
import { HttpHeader } from '../service/static.service';
import { CommonService } from '../service/common.service';
import { BaseModal } from '../../src/model/base';
import {MessageclientService} from '../service/messageclient.service';
/**
 * 
 * npm install  buffer --save
 * import { Buffer } from 'buffer';
 */
// import { Buffer } from 'buffer';
declare var app;
@Injectable({
  providedIn: 'root'
})
/**请求数据实体 */
export class HttpCustomerService {

  constructor(private http: HttpClient, 
    private com: CommonService,
    private msg:MessageclientService,
    private base:BaseModal,
    private platform:Platform
    ) {
  }
  /**
   * Get请求数据
   * @param _url 请求地址
   */
  public async get(_url: string): Promise<any> {
    if (_url.indexOf("?") >= 0) { _url += "&"; } else { _url += "?"; }
    _url += "r=" + Math.random();
    return await this.http.get(_url, {}).pipe(
      // retry(3), // 重试失败的请求最多3次,针对网络差的情况可多次请求
      tap( // Log the result or error
        data => { return data },
        error => { this.handleError(error) }
      )
    ).toPromise();
  }
  /**
   * post请求数据
   * @param _url 传递的Api地址
   * @param body api对应的参数数据，JSON格式
   */
  public post(_url: string, _body: any):Promise<WebResponesContext>{
    let that = this;
    // console.log(_body);
    let StoreID =that.com.GetStorageKey("tbstore");
    if(StoreID){
      _body.StoreID=StoreID.ID;
    }
    return that.PostData(_url, _body);
    //#region  保持程序不能重复登录问题处理
          // //判断token是否过期
          // let GetTokenMessage: object = that.GetTokenTimeOut();
          // ///判断当前token是否过期
          // let tokenBody = {};//TOKENURL
          // if (Object.keys(GetTokenMessage).length > 0 && _body.specialparameter!="login") {
          // tokenBody = GetTokenMessage;
          // return that.PostData(app.TOKENURL, tokenBody).then((data:any)=>{
          // if(data.ResponseMessage.Success){
          //   that.com.SaveStorage(data);
          //   that.com.getOutnumber();
          //   return that.PostData(_url, _body);
          // }else{
          //   return new Promise<WebResponesContext>((resolve,reject)=>{
          //     try{
          //       that.ErrorMessage.Parameters=_body;
          //       that.ErrorMessage.ErrorMessage=data;
          //     }catch(err){
          //       console.log(err);
          //     }
          //     reject(data);
          //   });
          // }
          // }).catch(error=>{
          // return new Promise<WebResponesContext>((resolve,reject)=>{
          //   let errormsg = "";
          //   if(error.error){
          //     errormsg = error.error;
          //   }else{
          //     errormsg = error;
          //   }
          //   if(errormsg["ResponseMessage"].ErrorMessage.indexOf('RefreshToken')>=0){
          //     if(!localStorage.getItem("passtoken")){
          //       localStorage.setItem("passtoken","true");
          //       that.msg.Alert("密码已失效,请重新登录").then((msg)=>{
          //         localStorage.removeItem("passtoken");
          //         that.com.LoginOutToken();
          //       })
          //     }
          //   }
          //   reject(errormsg);
          // });
          // });
          // }else{
          // return that.PostData(_url, _body);
          // }
    //#endregion
    
}
  /**
   * Post请求
   * @param _url 请求的url地址
   * @param _body 请求的参数
   */
  private PostData(_url: string, _body: object):Promise<WebResponesContext> {
    const that = this;
    delete _body["Account"];//清除掉用户信息
    delete _body["ResponseMessage"];//清除掉消息内容模块
    console.log("请求之前事件");
    return new Promise<WebResponesContext>((resolve,reject)=>{
      that.com.GetStaticObject();
       that.http.post<WebResponesContext>(_url, _body, that.getHttpHeaders()).pipe(
        //retry(3), // 重试失败的请求最多3次,针对网络差的情况可多次请求
        tap( // Log the result or error
          (data: WebResponesContext) => { 
            try{
              if(!data.ResponseMessage.Success){
                let errLog={Body:_body,Error:data};
                that.com.WriteExistingFile(JSON.stringify(errLog),"apiError_"+that.com.GetAccount.LoginName+"_"+that.com.getNow+".txt").then(data=>{
                  console.log(data);
                 }).catch(err=>{
                   console.log(err);
                 });
              }
            }catch(err){
              console.log(err);
            }
            return data; 
          },
          (error: WebResponesContext) => { 
            // console.log(error);
            let errorMsg = new WebResponesContext();
                errorMsg.ResponseMessage.Success = false;
                errorMsg.ResponseMessage.ErrorCode=error["status"];
                errorMsg.ResponseMessage.ErrorMessage = app.ERRORMESSAGE;
            if(error.ResponseMessage){
              errorMsg.ResponseMessage.ErrorMessage=error.ResponseMessage.ErrorMessage;
              //return error.ResponseMessage.ErrorMessage;
              // that.msg.Show(error.ResponseMessage.ErrorMessage,"middle");
            }else if(error["error"]){
               if(error["error"]["ResponseMessage"]){
                errorMsg.ResponseMessage = error["error"]["ResponseMessage"];
                 //return error["error"]["ResponseMessage"];
                // that.msg.Show(error["error"].ResponseMessage.ErrorMessage);
              }else{
                //errorMsg.ResponseMessage.ErrorMessage = error["message"];
                //return error["message"];
                //that.msg.Show(error["message"]);
              }
            }
            else if(error["message"]){
              // that.msg.Show(error["message"]);
              //errorMsg.ResponseMessage.ErrorMessage = error["message"];
              //return error["message"];
            }
            if(errorMsg.ResponseMessage.ErrorCode==401){
              if(!localStorage.getItem("unlogin")){
                localStorage.setItem("unlogin",JSON.stringify({"islogin":true}));
                that.msg.Alert("您的密码已失效,请重新登录","","确定",false).then(err=>{
                    localStorage.removeItem("passtoken");
                    localStorage.removeItem("unlogin");
                  that.com.LoginOutToken();
                });
              }
             
            }
            console.log(errorMsg,"请求异常");
            return errorMsg;
           }
        )
      ).toPromise().then(data=>{
      resolve(data);
      }).catch(error=>{
        console.log(error);
        console.log(error,"请求异常catch");
        let errorMsg = new WebResponesContext();
                errorMsg.ResponseMessage.Success = false;
                errorMsg.ResponseMessage.ErrorCode = error["status"];
                errorMsg.ResponseMessage.ErrorMessage = app.ERRORMESSAGE;
            if(error.ResponseMessage){
              errorMsg.ResponseMessage.ErrorMessage=error.ResponseMessage.ErrorMessage;
              //return error.ResponseMessage.ErrorMessage;
              // that.msg.Show(error.ResponseMessage.ErrorMessage,"middle");
            }else if(error["error"]){
              if(error["error"]["ResponseMessage"]){
                errorMsg.ResponseMessage = error["error"]["ResponseMessage"];
                //return error["error"]["ResponseMessage"];
                // that.msg.Show(error["error"].ResponseMessage.ErrorMessage);
              }else{
                // errorMsg.ResponseMessage.ErrorMessage = error["message"];
                //return error["message"];
                //that.msg.Show(error["message"]);
              }
            }
            else if(error["message"]){
              // that.msg.Show(error["message"]);
              // errorMsg.ResponseMessage.ErrorMessage = error["message"];
              //return error["message"];
            }
            try{
              let errLog={Body:_body,Error:error};
              that.com.WriteExistingFile(JSON.stringify(errLog),"catch_"+that.com.GetAccount.LoginName+"_"+that.com.getNow+".txt").then(data=>{
               console.log(data);
              }).catch(err=>{
                console.log(err);
              });
            }catch(err){
              console.log(err);
            }
          reject(errorMsg);
      });
    });
  }
  /**
   * 判断当前token是否快过期,小于2分钟则重新请求token
   * @param obj 
   */
  private GetTokenTimeOut(): object{
    let message: object = {};
    let that = this;
    if (that.com.getToken) {
      let token = that.com.getToken.AccessToken;//获取当前登录token值
      // let Stampdiffer: number = 0;//算出时间差
      if (that.com.GetAccount.IsLogin) {
        let exp = localStorage.getItem("exp");//过期时间戳
        let OutTimesTamp = parseInt(exp);//过期时间戳
       // console.log("exp:"+OutTimesTamp);
        let timediffer = localStorage.getItem("timediffer");
        let Nowtimestamp = Math.round(new Date().getTime() / 1000);//获取当前时间的时间戳
        //console.log("now："+Nowtimestamp);
        let  Stampdiffer = (OutTimesTamp - (Nowtimestamp+ parseInt(timediffer)));//算出时间差
       // console.log(Stampdiffer);
        if (Stampdiffer<2) { //离过期还有2分钟将执行过期操作
          message["RequestBody"]={};
          message["RequestBody"]["UserId"] = that.com.GetAccount.Id;
          message["RequestBody"]["RefreshToken"] = that.com.getToken.RefreshToken;
          message["RequestBody"]["GrantType"] = "refresh_token";
          message["RequestBody"]=JSON.stringify(message["RequestBody"]);
        }
      }
    }
    return message;
  }
  /**配置请求表头 */
  private getHttpHeaders() {
    if(this.com.getToken){
      HttpHeader.Authorization='Bearer '+this.com.getToken.AccessToken;
    }
   
    return {
      headers: new HttpHeaders(HttpHeader)
    };
  }
  /**
   * 系统异常信息错误日志(系统原始错误信息)
   */
  get ErrorMessage(){
    const that = this;
    let now = new Date();
    return {"Account":that.com.GetAccount,"Parameters":{},"ErrorMessage":{},"Data":now.toTimeString()};
  }
  /**
   * 处理错误信息返回
   * @param error 
   */
  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.log(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);
    }
    // return an observable with a user-facing error message
    return throwError(
      '请求数据失败;请稍后再试.');
  };
    /**
 * 获取系统是否升级操作
 */
GetAppPackage(){
  const that =this;
  return new Promise<WebResponesContext>((resolve,reject)=>{
    let body = new WebParameterContext();
    if(that.platform.is("cordova")){
      body.ConfigName="SystemAppVersion";
      body.ConfigType="view";
      body.OpType="query";
      let isrequest = 1;
       let sy=that.com.GetStorageKey("account");
       console.log(sy);
        if(that.platform.is("android"))
        {
                isrequest=0;
        }
         
         console.log(sy);
         let bodys = {"AndroidOrIos":isrequest,"AppVersion":sy.AppVersion};
         bodys["VersionType"]=that.base.Science;//判断是正式版本还是测试版本
            console.log(bodys,"版本更新");
      body.RequestBody = JSON.stringify(bodys);
      that.post(app.UPDATEAPPSITE,body).then((data:WebResponesContext)=>{
        if(data.ResponseMessage.Success){
          resolve(data);
        }else{
          reject(data);
        }
      }).catch(err=>{
        reject(err);
      });
    }else{
     let error=new WebResponesContext();
          error.ResponseMessage.Success=false;
          error.ResponseMessage.ErrorMessage="app端支持版本更新";
      reject(error);
    }
  });
}
/**
 * 初始化系统配置文件
 */
InitializationData():Promise<any>{
  const that=this;
  return new Promise<any>((resolve,reject)=>{
    that.get("../assets/All.json").then((data)=>{
      let arrrayJson:any=[];
      let stamp=data.stamp||data.Stamp;
      localStorage.setItem("pageConfigTime",stamp|| 1543905372);//缓存当前页面时间戳
      if(data["Pages"]){
        arrrayJson = data["Pages"];
      }else{
          arrrayJson=data;
      }
      resolve(arrrayJson);
    }).catch(err=>{
      reject("获取系统配置文件失败");
    });
  });
}

/**
 *  初始化微信权限配置
 * @param agentConfig 是否需要通过agentConfig注入应用的权限，默认不需要(false)。
 */
IsWeChatConfig(agentConfig:boolean=false):Promise<WebResponesContext>{
  const that =this;
  return new Promise<WebResponesContext>((resolve,reject)=>{
    let _webconfig:WebResponesContext=new WebResponesContext();
    let _appchat:any = that.com.GetStorageKey("wxconfig");
    console.log("判断微信权限");
    if(_appchat){
      that.com.WXConfig().then(config=>{
        if(agentConfig){
          console.log("判断微信应用权限");
          let _webchat:any=_appchat.agentConfig;
          console.log(_webchat,"agentConfig参数");
         that.com.AgentConfig(_webchat.corpid,_webchat.agentid,_webchat.timestamp,_webchat.nonceStr,_webchat.signature,_webchat.jsApiList).then(res=>{
           console.log(JSON.stringify(res),"应用权限回调成功");
          //  that.msg.Alert(JSON.stringify(res));
          resolve(_webconfig);
         }).catch(res=>{
          console.log(JSON.stringify(res),"应用权限回调失败");
          if(res.ResponseMessage){
            _webconfig.ResponseMessage.ErrorMessage=res.ResponseMessage.ErrorMessage;
          }else{
            _webconfig.ResponseMessage.ErrorMessage=res.message||res;
          }
          _webconfig.ResponseMessage.Success=false;
          try{
            that.RequestWXAuthorizationLog(_webconfig.ResponseMessage.ErrorMessage,"JSSDK授权").then(res=>{
               console.log(res);
            }).catch(err=>{
              console.log(err);
            });
          }catch(err){
            console.log(err);
          }
          reject(_webconfig);
         });
        }else{
          resolve(_webconfig);
        }
      }).catch(err=>{//如果授权失败,重新授权
        try{
          let msg=err.message||err;
          if(err.ResponseMessage){
            msg=err.ResponseMessage.ErrorMessage;
          }
          that.RequestWXAuthorizationLog(msg).then(res=>{
             console.log(res);
          }).catch(err=>{
            console.log(err);
          });
        }catch(err){
          console.log(err);
        }
        //#region  请求接口获取权限
        that.msg.Confirm("微信授权失败,是否再次获取微信授权","退出登录","确认授权","",false).then(res=>{
          if(res){
            that.RequestWXAuthorization("权限失效,正在获取微信授权,请稍后...",true).then(message=>{
              that.IsWeChatConfig(agentConfig);//回滚方法
             }).catch(err=>{
              _webconfig.ResponseMessage.ErrorMessage=err.ResponseMessage.ErrorMessage;
              _webconfig.ResponseMessage.Success=false;
              try{
                let msg=err.message||err;
                if(err.ResponseMessage){
                  msg=err.ResponseMessage.ErrorMessage;
                }
                that.RequestWXAuthorizationLog(msg,"JSSDK授权").then(res=>{
                   console.log(res);
                }).catch(err=>{
                  console.log(err);
                });
              }catch(err){
                console.log(err);
              }
              reject(_webconfig);
             });
          }else{
               _webconfig.ResponseMessage.ErrorMessage=err.ResponseMessage.ErrorMessage;
              _webconfig.ResponseMessage.Success=false;
              reject(_webconfig);
            that.com.LoginOutToken();
          }
        });
        
        //#endregion 请求接口结束
      });
    }else{
      //#region  请求接口获取权限
       that.RequestWXAuthorization().then(message=>{
        that.IsWeChatConfig(agentConfig);//回滚方法
       }).catch(err=>{
        _webconfig.ResponseMessage.ErrorMessage=err.ResponseMessage.ErrorMessage;
        _webconfig.ResponseMessage.Success=false;
        reject(_webconfig);
       });
      //#endregion 请求接口结束
    }
  });
}
/**
 * 获取微信授权
 * @param message 提供消息提示语
 * @param IsParms 是否强制获取票据
 */
RequestWXAuthorization(message:string=undefined,IsParms:boolean=false):Promise<WebResponesContext>{
  const that =this;
  return new Promise<WebResponesContext>((resolve,reject)=>{
    let _webconfig:WebResponesContext=new WebResponesContext();
    let _config:any={};
    let body = new WebParameterContext();
    body.ConfigName = "WeChatPublicNumber";
    body.OpType = "query";
    body.ConfigType = "view";
    body.Client.ApiType = "Content";
    body.Client.ClientType = 2;
    let request={};
    //0企业微信  1微信小程序
    request["Type"]=app.WXTYPE;
    // request["Url"]="http://apptest.mobizone.cn/";
    body.RequestBody = JSON.stringify(request);
    if(message){
      that.msg.Loading(message).then(load=>{
        let _url:any=app.WXJSSDKURL;
        if(IsParms){
          _url=_url+"?isEmptyCache=true"
        }
      that.post(_url, body).then(
        data => {
          load.dismiss();
          if (data.ResponseMessage.Success) {
              let res=data.Status;
              console.log("wxconfigapi成功");
              _config= {
                beta: true,// 必须这么写，否则wx.invoke调用形式的jsapi会有问题
                // debug: app.DEBUG, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                appId:res.Appid, // 必填，企业号的唯一标识，此处填写企业号corpid
                timestamp:res.Timestamp, // 必填，生成签名的时间戳
                nonceStr: res.Noncestr, // 必填，生成签名的随机串
                signature: res.Signature,// 必填，签名，见附录1
                jsApiList: res.JsSDKUrl // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
            };
            //通过agentConfig注入应用的权限
            let _agentConfig:any={
              corpid:res.Appid, // 必填，企业微信的corpid，必须与当前登录的企业一致
              agentid:res.AgentId, // 必填，企业微信的应用id
              timestamp:res.Timestamp , // 必填，生成签名的时间戳
              nonceStr:res.Noncestr, // 必填，生成签名的随机串
              signature:res.AgentStignature,// 必填，签名，见附录1
              jsApiList:res.WeChatAuth
              // jsApiList:["selectExternalContact","openUserProfile","shareToExternalContact","sendChatMessage","getCurExternalContact","getCurExternalChat","navigateToAddCustomer"] //必填
            };
            let _configapp:any = {config:_config,agentConfig:_agentConfig};
            localStorage.setItem("wxconfig",JSON.stringify(_configapp));
            _webconfig.Status=_configapp;
            resolve(_webconfig);
          }else{
            _webconfig.ResponseMessage.ErrorMessage=app.WXERROR;
            _webconfig.ResponseMessage.Success=false;
            reject(_webconfig);
            // that.msg.Show(app.WXERROR);
          }
        }
      ).catch(error => {
          load.dismiss();
          console.log(error);
          _webconfig.ResponseMessage.ErrorMessage=app.WXERROR;
          _webconfig.ResponseMessage.Success=false;
          reject(_webconfig);
          // that.msg.Show(app.WXERROR);
      });
      load.present();
    });
    }else{
      that.post(app.WXJSSDKURL, body).then(
        data => {
          if (data.ResponseMessage.Success) {
              let res=data.Status;
              console.log("wxconfigapi成功");
              _config= {
                beta: true,// 必须这么写，否则wx.invoke调用形式的jsapi会有问题
                // debug: app.DEBUG, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                appId:res.Appid, // 必填，企业号的唯一标识，此处填写企业号corpid
                timestamp:res.Timestamp, // 必填，生成签名的时间戳
                nonceStr: res.Noncestr, // 必填，生成签名的随机串
                signature: res.Signature,// 必填，签名，见附录1
                jsApiList: res.JsSDKUrl // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
            };
            //通过agentConfig注入应用的权限
            let _agentConfig:any={
              corpid: res.Appid, // 必填，企业微信的corpid，必须与当前登录的企业一致
              agentid: res.AgentId, // 必填，企业微信的应用id
              timestamp:res.Timestamp , // 必填，生成签名的时间戳
              nonceStr: res.Noncestr, // 必填，生成签名的随机串
              signature: res.AgentStignature,// 必填，签名，见附录1
              jsApiList:res.WeChatAuth
              // jsApiList:["selectExternalContact","openUserProfile","shareToExternalContact","sendChatMessage","getCurExternalContact","getCurExternalChat","navigateToAddCustomer"] //必填
            };
            let _configapp:any = {config:_config,agentConfig:_agentConfig};
            localStorage.setItem("wxconfig",JSON.stringify(_configapp));
            _webconfig.Status=_configapp;
            resolve(_webconfig);
          }else{
            _webconfig.ResponseMessage.ErrorMessage=app.WXERROR;
            _webconfig.ResponseMessage.Success=false;
            reject(_webconfig);
          }
        }
      ).catch(error => {
          console.log(error);
          _webconfig.ResponseMessage.ErrorMessage=app.WXERROR;
          _webconfig.ResponseMessage.Success=false;
          reject(_webconfig);
      });
    }
  });
}
/**
 * 获取微信授权失败异常
 * @param message 错误信息
 * @param isType 错误类型
 */
RequestWXAuthorizationLog(message:string,isType:String="token获取"):Promise<WebResponesContext>{
  const that =this;
  return new Promise<WebResponesContext>((resolve,reject)=>{
    let _webconfig:WebResponesContext=new WebResponesContext();
    let _config:any={};
    let body = new WebParameterContext();
    body.ConfigName = "TBSystemErroLogXML";
    body.OpType = "ADD";
    body.ConfigType = "form";
    body.Client.ApiType = "Content";
    body.Client.ClientType = 2;
    let request={};
        request["a_Message"]=message;
        request["a_Name"]=isType;
    body.RequestBody = JSON.stringify(request);
    that.post(app.DEFAULTURL, body).then(data => {
      if (data.ResponseMessage.Success) {
        _webconfig.ResponseMessage=data.ResponseMessage;
        resolve(_webconfig);
      }else{
        _webconfig.ResponseMessage=data.ResponseMessage;
        reject(_webconfig);
      }
    }).catch(error => {
      console.log(error);
      _webconfig.ResponseMessage.ErrorMessage=error;
      _webconfig.ResponseMessage.Success=false;
      reject(_webconfig);
      // that.msg.Show(app.WXERROR);
  });
  });
}
/**
 * 退出系统登录
 */
GetLoginOut():Promise<any>{
  const that=this;
  return that.post(app.LOGINOUTURL,{});
}
}
